import { render, staticRenderFns } from "./EmployeeMaster.vue?vue&type=template&id=0fd6e51a&scoped=true"
import script from "./EmployeeMaster.vue?vue&type=script&lang=ts"
export * from "./EmployeeMaster.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeMaster.vue?vue&type=style&index=0&id=0fd6e51a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd6e51a",
  null
  
)

export default component.exports